import contactActions from "./actions";

//const contacts = new fakeData(10).getAll();

// const initState = new Map({
//   exercises,
//   seectedId: "",
//   editView: false
// });

const initState = {
  users: [],
  workouts: [],
  fullworkout: [],
  clipboardWorkoutLog: { name: "N/A" },
  selected_workout: null,
  showingAddUserModal: false,
  teams: [],
  invites: [],
};

export default function contactReducer(state = initState, action) {
  let users;

  switch (action.type) {
    case contactActions.CHANGE_CONTACT_SUCCESS:
      return {
        ...state,
        tracking_type: action.tracking_type,
        seectedId: action.id,
        editView: false,
      };
    case contactActions.ADD_CONTACT:
      return state
        .set("exercises", action.contacts)
        .set("seectedId", action.selectedId)
        .set("editView", true);
    case contactActions.EDIT_CONTACT:
      return state.set("exercises", action.contacts);
    case contactActions.DELETE__CONTACT:
      return state
        .set("exercises", action.contacts)
        .set("seectedId", action.seectedId);
    case contactActions.EDIT_VIEW:
      return {
        ...state,
        editView: action.view,
      };
    case "FETCH_USERS_SUCCESS":
      return {
        ...state,
        users: action.payload.users,
      };
    case "FETCH_WORKOUTS_SUCCESS":
      return { ...state, workouts: action.payload.workouts };
    case "FETCH_FULL_WORKOUT_SUCCESS":
      return { ...state, fullworkout: action.payload };
    case contactActions.SELECT_WORKOUT:
      return { ...state, selected_workout: action.payload };
    case contactActions.SHOW_ADD_USER_MODAL:
      return { ...state, showingAddUserModal: action.payload };
    case contactActions.ADD_USER:
      users = [...state.users];
      users.unshift(action.payload);
      return { ...state, users };
    case contactActions.SET_TEAMS:
      return { ...state, teams: action.payload };
    case contactActions.ADD_TEAM:
      let teams = [...state.teams];
      teams.unshift(action.payload);
      return { ...state, teams };
    case contactActions.PATCH_USER:
      users = [...state.users];
      let index = users.findIndex((u) => u.id === action.payload.id);
      users.splice(index, 1, action.payload);
      return {
        ...state,
        users,
      };
    case "FETCH_INVITES_SUCCESS":
      return { ...state, invites: action.payload };
    case "ADD_INVITE":
      let invites = [...state.invites];
      invites.push(action.payload);
      return { ...state, invites };
    default:
      return state;
  }
}

// export { users };
